export default __webpack_public_path__ + "static/media/1-06a.6949ed69.png";